function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPhlokk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.116327,0,0,0.116327,-87.5423,-137.997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1395.58,2058.3C1358.13,2058.3 1323.51,2054.32 1291.73,2046.38L1334.29,1874.43C1352.45,1881.24 1372.88,1884.64 1395.58,1884.64C1429.63,1884.64 1461.98,1878.12 1492.62,1865.06C1523.27,1852.01 1549.94,1834.13 1572.64,1811.43C1595.34,1788.73 1613.22,1762.06 1626.27,1731.42C1639.32,1700.77 1645.85,1667.86 1645.85,1632.67C1645.85,1598.62 1639.32,1566.56 1626.27,1536.48C1613.22,1506.4 1595.34,1480.02 1572.64,1457.32C1549.94,1434.62 1523.27,1416.74 1492.62,1403.69C1461.98,1390.64 1429.63,1384.11 1395.58,1384.11C1361.53,1384.11 1329.18,1390.64 1298.54,1403.69C1267.89,1416.74 1241.22,1434.62 1218.52,1457.32C1195.82,1480.02 1177.95,1506.4 1164.89,1536.48C1151.84,1566.56 1145.32,1598.62 1145.32,1632.67L1145.32,2454.97L971.661,2279.62L971.661,1632.67C971.661,1574.79 982.727,1520.03 1004.86,1468.38C1026.99,1416.74 1057.07,1371.62 1095.09,1333.04C1133.11,1294.44 1177.95,1263.8 1229.59,1241.1C1281.23,1218.4 1336.56,1207.05 1395.58,1207.05C1453.46,1207.05 1508.51,1218.4 1560.72,1241.1C1612.93,1263.8 1658.33,1294.44 1696.92,1333.04C1735.51,1371.62 1766.15,1416.74 1788.86,1468.38C1811.56,1520.03 1822.9,1574.79 1822.9,1632.67C1822.9,1691.69 1811.56,1747.02 1788.86,1798.67C1766.15,1850.31 1735.51,1895.42 1696.92,1934.01C1658.33,1972.6 1612.93,2002.96 1560.72,2025.1C1508.51,2047.23 1453.46,2058.3 1395.58,2058.3Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.58,2058.3C1358.13,2058.3 1323.51,2054.32 1291.73,2046.38L1334.29,1874.43C1352.45,1881.24 1372.88,1884.64 1395.58,1884.64C1429.63,1884.64 1461.98,1878.12 1492.62,1865.06C1523.27,1852.01 1549.94,1834.13 1572.64,1811.43C1595.34,1788.73 1613.22,1762.06 1626.27,1731.42C1639.32,1700.77 1645.85,1667.86 1645.85,1632.67C1645.85,1598.62 1639.32,1566.56 1626.27,1536.48C1613.22,1506.4 1595.34,1480.02 1572.64,1457.32C1549.94,1434.62 1523.27,1416.74 1492.62,1403.69C1461.98,1390.64 1429.63,1384.11 1395.58,1384.11C1361.53,1384.11 1329.18,1390.64 1298.54,1403.69C1267.89,1416.74 1241.22,1434.62 1218.52,1457.32C1195.82,1480.02 1177.95,1506.4 1164.89,1536.48C1151.84,1566.56 1145.32,1598.62 1145.32,1632.67L1145.32,2454.97L971.661,2279.62L971.661,1632.67C971.661,1574.79 982.727,1520.03 1004.86,1468.38C1026.99,1416.74 1057.07,1371.62 1095.09,1333.04C1133.11,1294.44 1177.95,1263.8 1229.59,1241.1C1281.23,1218.4 1336.56,1207.05 1395.58,1207.05C1453.46,1207.05 1508.51,1218.4 1560.72,1241.1C1612.93,1263.8 1658.33,1294.44 1696.92,1333.04C1735.51,1371.62 1766.15,1416.74 1788.86,1468.38C1811.56,1520.03 1822.9,1574.79 1822.9,1632.67C1822.9,1691.69 1811.56,1747.02 1788.86,1798.67C1766.15,1850.31 1735.51,1895.42 1696.92,1934.01C1658.33,1972.6 1612.93,2002.96 1560.72,2025.1C1508.51,2047.23 1453.46,2058.3 1395.58,2058.3Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.58,2058.3C1358.13,2058.3 1323.51,2054.32 1291.73,2046.38L1334.29,1874.43C1352.45,1881.24 1372.88,1884.64 1395.58,1884.64C1429.63,1884.64 1461.98,1878.12 1492.62,1865.06C1523.27,1852.01 1549.94,1834.13 1572.64,1811.43C1595.34,1788.73 1613.22,1762.06 1626.27,1731.42C1639.32,1700.77 1645.85,1667.86 1645.85,1632.67C1645.85,1598.62 1639.32,1566.56 1626.27,1536.48C1613.22,1506.4 1595.34,1480.02 1572.64,1457.32C1549.94,1434.62 1523.27,1416.74 1492.62,1403.69C1461.98,1390.64 1429.63,1384.11 1395.58,1384.11C1361.53,1384.11 1329.18,1390.64 1298.54,1403.69C1267.89,1416.74 1241.22,1434.62 1218.52,1457.32C1195.82,1480.02 1177.95,1506.4 1164.89,1536.48C1151.84,1566.56 1145.32,1598.62 1145.32,1632.67L1145.32,2454.97L971.661,2279.62L971.661,1632.67C971.661,1574.79 982.727,1520.03 1004.86,1468.38C1026.99,1416.74 1057.07,1371.62 1095.09,1333.04C1133.11,1294.44 1177.95,1263.8 1229.59,1241.1C1281.23,1218.4 1336.56,1207.05 1395.58,1207.05C1453.46,1207.05 1508.51,1218.4 1560.72,1241.1C1612.93,1263.8 1658.33,1294.44 1696.92,1333.04C1735.51,1371.62 1766.15,1416.74 1788.86,1468.38C1811.56,1520.03 1822.9,1574.79 1822.9,1632.67C1822.9,1691.69 1811.56,1747.02 1788.86,1798.67C1766.15,1850.31 1735.51,1895.42 1696.92,1934.01C1658.33,1972.6 1612.93,2002.96 1560.72,2025.1C1508.51,2047.23 1453.46,2058.3 1395.58,2058.3Z",
    style: {
      fill: "url(#_Linear3)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(915.939,0,-0,915.939,920.586,1632.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0,189,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236,0,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(915.939,0,-0,915.939,920.586,1632.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0,189,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236,0,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(915.939,0,-0,915.939,920.586,1632.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0,189,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236,0,255)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPhlokk);
export default __webpack_public_path__ + "static/media/logo_phlokk.9a2cc3cabc763f6f8d92319d37183286.svg";
export { ForwardRef as ReactComponent };